import { AppBar, Stack, Toolbar, Button, Box } from '@mui/material';
import { ReactNode } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import confideName from './../../assets/svg/confide.svg';
import confideLogo from './../../assets/svg/confideLogo.svg';
import menuIcon from './../../assets/svg/menuIcon.svg';
import menuIconActive from './../../assets/svg/menuIconActive.svg';

import { useAuth } from '../../contexts/auth/authContext';
interface HeaderProps {
  right?: ReactNode;
  setSidebarOpen?: (value: boolean) => void;
  isSidebarOpen?: boolean;
  isMenuHidden?: boolean;
}

const HeaderComponent = ({
  right,
  setSidebarOpen,
  isSidebarOpen,
  isMenuHidden,
}: HeaderProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { accessFlag } = useAuth();

  const isPublic =
    isMenuHidden ||
    !location.pathname.startsWith('/customer');

  const isCustomerRegisterErrorPage =
    location.pathname === '/customer/register/error';

  const MINI_BUTTON_WIDTH = 29;

  const appBarStyle: React.CSSProperties = {
    width: '100%',
    top: 0,
    backgroundColor: '#181818',
  };

  const handleClickHeaderLogo = () => {
    if (isPublic) {
      navigate('/');
    } else if (isCustomerRegisterErrorPage) {
      navigate('/customer/login');
    }
  };

  const handleToggleSidebar = () => {
    if (setSidebarOpen) {
      if (isSidebarOpen != undefined) {
        setSidebarOpen(!isSidebarOpen);
      }
    }
  };

  return (
    <AppBar
      className='header'
      style={appBarStyle}
      position='sticky'
      sx={{
        zIndex: 999,
        padding: { xs: '0 10px', md: '0 15px' },
      }}
    >
      <Stack
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        sx={{ width: '100%' }}
      >
        <Stack direction='row' alignItems='center' justifyContent='flex-start'>
          <Toolbar
            sx={{
              paddingX: 0,
            }}
          >
            {accessFlag && !isPublic && (
              <Button
                sx={{
                  width: MINI_BUTTON_WIDTH,
                  minWidth: MINI_BUTTON_WIDTH,
                  justifyContent: 'center',
                  height: MINI_BUTTON_WIDTH,
                  display: { sm: 'none', xs: 'flex' },
                  padding: 0,
                }}
                onClick={handleToggleSidebar}
              >
                <img
                  src={isSidebarOpen ? menuIconActive : menuIcon}
                  alt='Menu'
                  width={30}
                />
              </Button>
            )}
            <Button
              variant='text'
              onClick={handleClickHeaderLogo}
              sx={{
                '&:hover': {
                  background: 'none',
                },
              }}
            >
              <Box
                component='img'
                src={confideLogo}
                alt='Logo'
                sx={{
                  marginRight: 0,
                  marginLeft: { xs: 0, md: 10 },
                  height: 28,
                }}
              />
              <img
                src={confideName}
                alt='Confide'
                style={{ marginRight: 0, height: 16 }}
              />
            </Button>
          </Toolbar>
        </Stack>
        <Stack direction='row' alignItems='center' justifyContent='flex-end'>
          {right}
        </Stack>
      </Stack>
    </AppBar>
  );
};

export default HeaderComponent;
